(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-coastal-header"] && !Shopify.designMode) return;
  try {
    
  if (!window.acRefDialogs) {
    window.acRefDialogs = true;
    document.addEventListener('click', function(event){
      var opener=event.target.closest('[data-ac-dialog]');
      if(opener){var modal=document.getElementById(opener.dataset.acDialog);if(modal)modal.showModal();}
      var closer=event.target.closest('[data-ac-close]');
      if(closer){var dialog=closer.closest('dialog');if(dialog)dialog.close();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-coastal-home"] && !Shopify.designMode) return;
  try {
    
  function initAcHomeSlides(){
    document.querySelectorAll('.ac-ref-slide-tile').forEach(tile=>{
      if(tile.dataset.slideReady)return;
      tile.dataset.slideReady='true';
      const track=tile.querySelector('.ac-ref-slide-track');
      const slides=track.children;
      const controls=tile.querySelector('.ac-ref-slide-controls');
      if(slides.length<2){controls.hidden=true;return;}
      const output=controls.querySelector('output');
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      let index=0,holdUntil=0;
      function show(next){
        index=(next+slides.length)%slides.length;
        track.style.transform='translateX(-'+(index*100)+'%)';
        output.textContent=(index+1)+' / '+slides.length;
      }
      function manual(next){show(next);holdUntil=Date.now()+15000;}
      controls.querySelector('.ac-ref-slide-prev').addEventListener('click',()=>manual(index-1));
      controls.querySelector('.ac-ref-slide-next').addEventListener('click',()=>manual(index+1));
      setInterval(()=>{if(!document.hidden&&!reduced.matches&&Date.now()>=holdUntil)show(index+1);},5000);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAcHomeSlides,{once:true});else initAcHomeSlides();
  document.addEventListener('shopify:section:load',initAcHomeSlides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-acp-variant]')) return;
    const root = event.target.closest('.acp');
    const option = event.target.selectedOptions[0];
    root.querySelectorAll('[data-acp-price]').forEach(el => el.textContent = option.dataset.price);
    const compare = root.querySelector('[data-acp-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = !option.dataset.compare;
    const badge = root.querySelector('[data-acp-save]');
    const saving = root.querySelector('[data-acp-saving]');
    if (badge) { badge.textContent = option.dataset.save; badge.hidden = !option.dataset.save; }
    if (saving) { saving.textContent = option.dataset.saving; saving.hidden = !option.dataset.saving; }
    root.querySelectorAll('[data-acp-add]').forEach(button => { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? button.dataset.sold : button.dataset.add; });
    const quantity = root.querySelector('input[name="quantity"]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    const media = Array.from(root.querySelectorAll('[data-media-id]')).find(el => el.dataset.mediaId === option.dataset.media);
    if (media) { root.querySelectorAll('.acp-featured').forEach(el => el.classList.remove('acp-featured')); media.classList.add('acp-featured'); root.dispatchEvent(new CustomEvent('acp:mediachange',{detail:{mediaId:option.dataset.media}})); }
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });

  function initAcMobileGallery(root){
    const grid=root.querySelector('.acp-media-grid');
    const slides=Array.from(grid?.querySelectorAll('.acp-media')||[]);
    const controls=root.querySelector('.acp-gallery-controls');
    if(!grid||!controls||slides.length<2){if(controls)controls.hidden=true;return;}
    const count=controls.querySelector('.acp-gallery-count');
    const mobile=window.matchMedia('(max-width: 899px)');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    let index=Math.max(0,slides.findIndex(el=>el.classList.contains('acp-featured')));
    let holdUntil=0;
    let startX=null;
    function show(next){
      index=(next+slides.length)%slides.length;
      slides.forEach((slide,i)=>{
        slide.classList.toggle('is-current',i===index);
        slide.setAttribute('aria-hidden',mobile.matches&&i!==index?'true':'false');
      });
      grid.classList.toggle('acp-slider-ready',mobile.matches);
      count.textContent=(index+1)+' / '+slides.length;
      controls.hidden=!mobile.matches;
    }
    function manual(next){show(next);holdUntil=Date.now()+15000;}
    controls.querySelector('.acp-gallery-prev').addEventListener('click',()=>manual(index-1));
    controls.querySelector('.acp-gallery-next').addEventListener('click',()=>manual(index+1));
    grid.addEventListener('touchstart',event=>{startX=event.changedTouches[0].screenX},{passive:true});
    grid.addEventListener('touchend',event=>{
      if(startX===null)return;
      const delta=event.changedTouches[0].screenX-startX;
      if(Math.abs(delta)>45)manual(index+(delta<0?1:-1));
      startX=null;
    },{passive:true});
    root.addEventListener('acp:mediachange',event=>{
      const found=slides.findIndex(el=>el.dataset.mediaId===event.detail.mediaId);
      if(found>=0)show(found);
    });
    mobile.addEventListener('change',()=>show(index));
    show(index);
    setInterval(()=>{
      if(!mobile.matches||reduced.matches||document.hidden||Date.now()<holdUntil)return;
      show(index+1);
    },6000);
  }
  function initAcPreserveGallery(root){
    root.querySelectorAll('.acp-preserve-gallery').forEach(gallery=>{
    if(gallery.dataset.ready)return;
    gallery.dataset.ready='true';
    const track=gallery.querySelector('.acp-preserve-track');
    const count=gallery.querySelector('.acp-preserve-count');
    const slides=track.children;
    if(slides.length<2){gallery.querySelector('.acp-preserve-controls').hidden=true;return;}
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    let index=0,holdUntil=0;
    function show(next){
      index=(next+slides.length)%slides.length;
      track.style.transform='translateX(-'+(index*100)+'%)';
      count.textContent=(index+1)+' / '+slides.length;
    }
    function manual(next){show(next);holdUntil=Date.now()+15000;}
    gallery.querySelector('.acp-preserve-prev').addEventListener('click',()=>manual(index-1));
    gallery.querySelector('.acp-preserve-next').addEventListener('click',()=>manual(index+1));
    setInterval(()=>{if(!document.hidden&&!reduced.matches&&Date.now()>=holdUntil)show(index+1);},5000);
    });
  }
  function initAcGalleries(){document.querySelectorAll('.acp').forEach(root=>{if(!root.dataset.acpGalleryReady){root.dataset.acpGalleryReady='true';initAcMobileGallery(root);}initAcPreserveGallery(root);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAcGalleries,{once:true});else initAcGalleries();
  document.addEventListener('shopify:section:load',initAcGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
